module.exports = __webpack_public_path__ + "static/media/logo@2x.f0ffd680.png";